import React from "react";
import { Box } from "@mui/material";
import {
  useMyTimesheetDashboardDate,
  useMyTimesheetRequestsBadge,
} from "my-timesheet/hooks";
import { OcSidebarBadge } from "oc/components/sidebar-badge";

export const MyTimesheetMenuBadge = () => {
  const { periodStart, periodEnd } = useMyTimesheetDashboardDate(
    "examinerUserRequests",
  );

  const { data: badgeCount } = useMyTimesheetRequestsBadge({
    startDate: periodStart.toISOString(),
    endDate: periodEnd.toISOString(),
  });

  if (!badgeCount) return null;

  return (
    <Box display="flex" flexDirection="row" alignItems="center">
      <OcSidebarBadge id="MyTimesheetMenuBadge" value={badgeCount} urgent />
    </Box>
  );
};

export default MyTimesheetMenuBadge;
